import './App.css';
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Routes, Route } from "react-router-dom";
import PrivateRoute from './routes/PrivateRoute';

import Login from './pages/auth/Login';
import Otp from "./pages/auth/Otp";
import HomePage from "./components/home/Home";
import PageNotFound from "./components/layout/PageNotFound";
import AppLayout from './components/layout/AppLayout';
import RolePage from './pages/role/RolePage';
import BusinessType from './pages/bussinessType/BusinessType';
import Cluster from './pages/cluster/Cluster';
import Chapter from './pages/chapter/Chapter';
import Responsibility from './pages/responsibility/Responsibility';
import User from './pages/user/Userindex';
import UserCreate from './pages/user/Usercreate';
import UserView from './pages/user/UserView';
import BusinessCategory from './pages/bussinessCategory/BusinessCategory';
import BusinessSubCategory from './pages/bussinessSubCategory/BusinessSubCategory';
import BusinessFormation from './pages/bussinessFormation/BusinessFormation';
import BusinessProductservice from './pages/bussinessProductservice/BusinessProductservice';
import EventType from './pages/eventType/EventType';
import Vanue from './pages/eventVanue/Vanueindex';
import VanueCreate from './pages/eventVanue/Vanuecreate';
import EventCreate from './pages/event/Eventcreate';
import EventView from './pages/event/Eventview';
import Event from './pages/event/Eventindex';
import Guest from './pages/guest/Guestindex';
import GuestCreate from './pages/guest/Guestcreate';
import Setting from './pages/setting/Setting';
import Banner from './pages/banner/Banner';
import City from './pages/city/City';
import Country from './pages/country/Country';
import State from './pages/state/State';
import Tax from './pages/tax/Tax';
import Fees from './pages/fees/Fees';
import CoreTeam from './pages/coreTeam/CoreTeam';
import ContributionTeam from './pages/contributionTeam/ContributionTeam';
import GrowthPartner from './pages/growthPartner/GrowthPartner';
import GrowthPartnerCluster from './pages/growthPartnerCluster/GrowthPartnerCluster';
import Team from './pages/team/TeamPage';
import ContributionLeval from './pages/contributionLeval/ContributionLeval';
import Core from './pages/core/Core';
import MobileSetting from './pages/mobileSetting/MobileSetting';
import PdfCategory from './pages/pdfCategory/PdfCategory';
import Slider from './pages/slider/Slider';
import SmallBanner from './pages/smallBanner/SmallBanner';
import Pdf from './pages/pdf/Pdf';
import Notification from './pages/notification/Notification';
import Report from './pages/report/Report';
import Ticket from './pages/ticket/Ticket';
import Tag from './pages/tag/Tag';
import PartnerRequest from './pages/partnerRequest/PartnerRequest';

function App() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/otp" element={<Otp />} />

            <Route element={
                <PrivateRoute>
                    <AppLayout />
                </PrivateRoute>
            }>
                <Route path="dashboard" element={<HomePage />} />
                <Route path="user" element={<User />} />
                <Route path="user/create" element={<UserCreate />} />
                <Route path="user/edit/:id" element={<UserCreate />} />
                <Route path="user/view/:id" element={<UserView />} />
                <Route path="role" element={<RolePage />} />
                <Route path="cluster" element={<Cluster />} />
                <Route path="responsibility" element={<Responsibility />} />
                <Route path="chapter" element={<Chapter />} />
                <Route path="businessType" element={<BusinessType />} />
                <Route path="businessCategory" element={<BusinessCategory />} />
                <Route path="businessSubCategory" element={<BusinessSubCategory />} />
                <Route path="businessProductservice" element={<BusinessProductservice />} />
                <Route path="businessFormation" element={<BusinessFormation />} />
                <Route path="eventType" element={<EventType />} />
                <Route path="vanue" element={<Vanue />} />
                <Route path="vanue/create" element={<VanueCreate />} />
                <Route path="vanue/edit/:id" element={<VanueCreate />} />
                <Route path="event" element={<Event />} />
                <Route path="event/create" element={<EventCreate />} />
                <Route path="event/edit/:id" element={<EventCreate />} />
                <Route path="event/view/:id" element={<EventView />} />
                <Route path="guest" element={<Guest />} />
                <Route path="guest/create" element={<GuestCreate />} />
                <Route path="guest/edit/:id" element={<GuestCreate />} />
                <Route path="guest/view/:id" element={<UserView />} />
                <Route path="setting" element={<Setting />} />
                <Route path="banner" element={<Banner />} />
                <Route path="city" element={<City />} />
                <Route path="state" element={<State />} />
                <Route path="country" element={<Country />} />
                <Route path="tax" element={<Tax />} />
                <Route path="fees" element={<Fees />} />
                <Route path="coreTeam" element={<CoreTeam />} />
                <Route path="contributionTeam" element={<ContributionTeam />} />
                <Route path="growthPartner" element={<GrowthPartner />} />
                <Route path="growthPartnerCluster" element={<GrowthPartnerCluster />} />
                <Route path="team" element={<Team />} />
                <Route path="contributionLeval" element={<ContributionLeval />} />
                <Route path="core" element={<Core />} />
                <Route path="mobileSetting" element={<MobileSetting />} />
                <Route path="pdfCategory" element={<PdfCategory />} />
                <Route path="slider" element={<Slider />} />
                <Route path="smallBanner" element={<SmallBanner />} />
                <Route path="pdf" element={<Pdf />} />
                <Route path="notification" element={<Notification />} />
                <Route path="report" element={<Report />} />
                <Route path="ticket" element={<Ticket />} />
                <Route path="tag" element={<Tag />} />
                <Route path="partnerRequest" element={<PartnerRequest />} />
            </Route>
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}

export default App;